//* 스타디아 웹 결제 페이지 (Paddle 등 연동 시 이 페이지에서 체크아웃 진행)
// 2025.02
// 희문

import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

const StudentCheckout: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const coinProductId = searchParams.get("coinProductId");
    const storeSkuId = searchParams.get("storeSkuId");

    useEffect(() => {
        // TODO: Paddle Checkout 연동 시 여기서 Paddle.Checkout.open({ product: storeSkuId }) 등 호출
        // 현재는 플레이스홀더. 연동 후 결제 완료 시 /student/my/stadia 등으로 이동
    }, [coinProductId, storeSkuId]);

    return (
        <div className="min-h-[60vh] flex flex-col items-center justify-center px-4">
            <p className="text-gray-600 mb-4">
                {getLanguageValue(PAGE_TYPE.STUDENT, "coinStore.txtLoading")}
            </p>
            <p className="text-sm text-gray-400 mb-6">
                coinProductId: {coinProductId || "-"} / storeSkuId: {storeSkuId || "-"}
            </p>
            <button
                type="button"
                onClick={() => navigate("/student")}
                className="text-sm text-gray-500 underline"
            >
                홈으로
            </button>
        </div>
    );
};

export default StudentCheckout;
